import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

function Districts() {
  const [districts, setDistricts] = useState([]);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(null);

  const token = localStorage.getItem('token');

  const load = useCallback(() => {
    axios.get(`${API}/districts`, { headers: { authorization: token } })
      .then(res => setDistricts(res.data))
      .catch(() => setError(tr("Tumanlar ro'yxatini olishda xato")));
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const create = async () => {
    setError('');
    setSuccess('');
    if (!name.trim()) { setError(tr("Tuman nomini kiriting")); return; }

    setSaving(true);
    try {
      await axios.post(`${API}/districts`, { name }, { headers: { authorization: token } });
      setSuccess(tr("\"{name}\" qo'shildi.", { name }));
      setName('');
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("Tuman qo'shilmadi."));
    } finally {
      setSaving(false);
    }
  };

  const saveEdit = async () => {
    setError('');
    if (!editing.name.trim()) { setError(tr("Tuman nomini kiriting")); return; }
    try {
      await axios.put(`${API}/districts/${editing.id}`, editing, {
        headers: { authorization: token }
      });
      setSuccess(tr("Tuman yangilandi."));
      setEditing(null);
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("Saqlanmadi."));
    }
  };

  const remove = async (d) => {
    setError('');
    setSuccess('');
    const ogoh = d.xodimlar_soni > 0
      ? tr("\"{name}\" o'chirilsinmi?\n\nDIQQAT: {soni} ta xodimning tuman biriktiruvi bekor qilinadi va ular yig'ilishda ko'rinmay qoladi.", { name: d.name, soni: d.xodimlar_soni })
      : tr("\"{name}\" tumani o'chirilsinmi?", { name: d.name });
    if (!window.confirm(ogoh)) return;

    try {
      const res = await axios.delete(`${API}/districts/${d.id}`, {
        headers: { authorization: token }
      });
      setSuccess(res.data.message);
      load();
    } catch (err) {
      setError(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: '8px', fontSize: '22px' }}>{tr("Tumanlar")}</h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {tr("Ovozli yig'ilishning asosiy birligi. Rahbar yig'ilishda aynan tumanlarni ko'radi va so'z beradi — shuning uchun har bir ishtirokchi xodim tumanga biriktirilgan bo'lishi shart.")}
      </p>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)', marginBottom: '24px' }}>
        <h3 style={{ marginBottom: '16px', fontSize: '16px' }}>{tr("Yangi tuman")}</h3>

        <div style={{ display: 'flex', gap: '12px' }}>
          <input
            type="text"
            placeholder={tr("Tuman nomi * (masalan: Chilonzor)")}
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && create()}
            style={{ ...inputStyle, flex: 1 }}
          />
          <button
            onClick={create}
            disabled={saving}
            style={{
              padding: '10px 24px',
              background: saving ? '#888' : '#1a1a2e',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              cursor: saving ? 'default' : 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            {saving ? tr("Qo'shilmoqda...") : tr("Qo'shish")}
          </button>
        </div>

        {error && (
          <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '12px' }}>
            {success}
          </div>
        )}
      </div>

      <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 8px rgba(0,0,0,0.06)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Nomi")}</th>
              <th style={{ textAlign: 'center', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Xodimlar")}</th>
              <th style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Holat")}</th>
              <th style={{ textAlign: 'right', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{tr("Amallar")}</th>
            </tr>
          </thead>
          <tbody>
            {districts.map(d => (
              <tr key={d.id} style={{ borderBottom: '1px solid #f9f9f9', opacity: d.is_active ? 1 : 0.5 }}>
                <td style={{ padding: '10px 8px', fontWeight: '500' }}>
                  {editing?.id === d.id ? (
                    <input
                      type="text"
                      value={editing.name}
                      onChange={e => setEditing({ ...editing, name: e.target.value })}
                      onKeyDown={e => e.key === 'Enter' && saveEdit()}
                      autoFocus
                      style={{ ...inputStyle, padding: '6px 10px', width: '100%' }}
                    />
                  ) : d.name}
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'center', color: d.xodimlar_soni > 0 ? '#555' : '#c93636' }}>
                  {d.xodimlar_soni}
                </td>
                <td style={{ padding: '10px 8px' }}>
                  {editing?.id === d.id ? (
                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#555' }}>
                      <input
                        type="checkbox"
                        checked={editing.is_active}
                        onChange={e => setEditing({ ...editing, is_active: e.target.checked })}
                      />
                      {tr("Faol")}
                    </label>
                  ) : (
                    <span style={{
                      background: d.is_active ? '#e9f9ed' : '#f0f0f0',
                      color: d.is_active ? '#2d8a2d' : '#999',
                      padding: '3px 10px',
                      borderRadius: '20px',
                      fontSize: '12px'
                    }}>
                      {d.is_active ? tr("Faol") : tr("O'chiq")}
                    </span>
                  )}
                </td>
                <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  {editing?.id === d.id ? (
                    <>
                      <button onClick={saveEdit} style={{ ...smallBtn, marginRight: '6px', background: '#1a1a2e', color: '#fff' }}>
                        {tr("Saqlash")}
                      </button>
                      <button onClick={() => setEditing(null)} style={smallBtn}>
                        {tr("Bekor")}
                      </button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditing({ ...d })} style={{ ...smallBtn, marginRight: '6px' }}>
                        {tr("Tahrirlash")}
                      </button>
                      <button onClick={() => remove(d)} style={{ ...smallBtn, color: '#c93636' }}>
                        {tr("O'chirish")}
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {districts.length === 0 && (
          <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
            {tr("Hali tuman qo'shilmagan. Tumansiz ovozli yig'ilish o'tkazib bo'lmaydi.")}
          </p>
        )}
      </div>
    </div>
  );
}

export default Districts;
